import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "velluto" },
});

// Strict gate: any restricted call by an unverified member sends them to the Verification Required page.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response?.data?.detail;
    if (err.response?.status === 403 && d && typeof d === "object" && d.code === "verification_required"
        && window.location.pathname !== "/verify") {
      window.location.assign("/verify");
    }
    if (err.response?.status === 403 && d && typeof d === "object" && d.code === "email_unverified"
        && window.location.pathname !== "/confirm-email") {
      window.location.assign("/confirm-email");
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}
